import axios from 'axios';
import Cookies from 'js-cookie';

// Router
import router from '../router';

// Initial config
const api = axios.create({
  baseURL: '',
  timeout: 5000,
  params: {},
  headers: {
    'Content-Type': 'application/json'
  }
});

// Axios response interceptor
api.interceptors.response.use((response) => Promise.resolve(response), (error) => {
  const { response: { status } } = error;
  if (status === 401) {
    // Remove token
    localStorage.removeItem('token');
    // Logged out
    router.go('/login');
    return;
  }
  return Promise.reject(error);
});

// Axios request interceptor
api.interceptors.request.use((request) => {
  // Get stored token (if any)
  const token = localStorage.getItem('token');
  request.headers.common = {
    ...request.headers.common,
    Authorization: token ? `Token ${token}` : '',
    'X-CSRFToken': Cookies.get('csrftoken')
  };
  return request;
});

export default api;